/* src/app/shared/components/header/header.component.scss */
.path-header {
  font-size: 14px;
  text-align: left;
  color: #333333;
  margin-bottom: 24px;
}
.path-header a {
  color: #333333;
  text-decoration: underline;
}
.path-item {
  display: flex;
}
.p-item {
  display: flex;
}
.back {
  background-color: #61566e;
  padding: 4px 4px 4px 4px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  cursor: pointer;
}
.back img {
  height: 18px;
  width: 18px;
}
.path-back {
  background-color: #d8d8d8;
  color: black;
  padding: 7px 10px 6.5px 15px;
  font-size: 11px;
  text-decoration: none !important;
  margin-left: 4px;
  cursor: pointer;
}
.path-current {
  background-color: #61566e;
  color: white;
  padding: 7px 0px 6.5px 0px;
  margin-left: -8px;
  font-size: 11px;
  text-decoration: none !important;
  z-index: 101;
}
.path-back-arrow {
  border-top: 14px solid transparent;
  border-right: 14px solid transparent;
  border-bottom: 14px solid transparent;
  border-left: 14px solid #d8d8d8;
  z-index: 100;
}
.path-current-before-arrow {
  border-top: 14px solid #61566e;
  border-right: 14px solid #61566e;
  border-bottom: 14px solid #61566e;
  border-left: 14px solid transparent;
  z-index: 100;
}
.path-current-arrow {
  border-top: 14px solid transparent;
  border-right: 14px solid transparent;
  border-bottom: 14px solid transparent;
  border-left: 14px solid #61566e;
  z-index: 100;
}
.path-current-container {
  margin-left: -20px;
  cursor: default;
}
.p-item:focus,
div:focus {
  outline: none;
}
.content-header {
  margin-bottom: 52px;
}
@media (max-width: 1199.98px) {
  .content-header {
    margin-bottom: 36px;
  }
}
@media (max-width: 991.98px) {
  .content-header {
    margin-bottom: 24px;
  }
}
@media (max-width: 575px) {
  .xs-hide {
    display: none;
  }
}
/*# sourceMappingURL=header.component.css.map */
